import React from 'react';
import ReactDOMServer from 'react-dom/server';

import FailsafeImg from 'components/global/application/FailsafeImg';
import { imageUrlEncode } from 'contexts/link_util';

interface Props {
    contentHtml: string;
}

const EmbeddedContent: React.StatelessComponent<Props> = (props: Props) => {
    let contentHtml  = props.contentHtml;
     /*
         * Gruhn's Drupal has the media module installed (https://www.drupal.org/project/media). This means their web content wysiwyg has an
         * 'Add Media' button to allow embedding of images in the body html. The resulting information is included inline with the html surrounded by
         * two consecutive brackets (eg. [[content_here]]) like such^:
         * "[[
         *  {
         *      "fid":"33425",
         *      "view_mode":"hg_media_image_larger",
         *      "fields":{
         *          "format":"hg_media_image_larger",
         *          "field_file_image_alt_text[und][0][value]":"",
         *          "field_file_image_title_text[und][0][value]":"",
         *          "field_folder[und]":"1"},
         *      "type":"media",
         *      "attributes":{
         *          "class":"media-element file-hg-media-image-larger"
         *      }
         *  }
         * ]]"
         *      ^ above example formatted with newlines and tabs for ease of reading
         *
         * To support this functionality, the following if block detects and parses this embedded information so it will be displayed as it does on the legacy site.
         * It also removes the raw data from the html to keep it from being displayed as plain text.
         *
    */
    let wysiwygEmbedFid: string = null;
    if (contentHtml && contentHtml.includes('[[') && contentHtml.includes(']]')) {
        const mediaEmbed = contentHtml.match(/\[\[.*?\]\]/g);

        mediaEmbed.forEach((e) => {
            const imgJson = e.slice(2, e.length - 2); // remove the surrounding square brackets
            wysiwygEmbedFid = JSON.parse(imgJson).fid;
            const img = (
                <div style={{ display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                    {wysiwygEmbedFid && <FailsafeImg style={{ maxWidth: '100%' }} src={imageUrlEncode(wysiwygEmbedFid)} />}
                </div>
            );
            const renderedImg  = ReactDOMServer.renderToStaticMarkup(img);
            contentHtml = contentHtml.replace(e, renderedImg);
        });
    }

    if (contentHtml && contentHtml.indexOf('\x03') !== -1) {
        contentHtml = contentHtml.replace(/\x03/g, '');
    }

    return(
    <span>
        {contentHtml && <div dangerouslySetInnerHTML={{ __html: contentHtml }} />}
    </span>
    );
};

export default EmbeddedContent;



// WEBPACK FOOTER //
// ./src/components/pages/default/EmbeddedContent.tsx